import type { TieredSubtitleProps } from './types'
import type { EventDescription } from '~/composables/types/event'
import { formatMoney } from '~/utils/currencyHelpers'
import { calculatePromotionDiscount } from '~/utils/pricingGetters'

const PRICE_FROM_KEY = 'product.show.checkout.priceFrom'

/**
 * @param localeBCP47 Locale in BCP47 format (e.g. "de-DE"), already converted by caller
 */
export const getTieredFromPricePerPerson = (
  kftEvent: EventDescription | undefined,
  localeBCP47: string,
  t: (key: string, params?: Record<string, unknown>) => string
): string | undefined => {
  const categories = kftEvent?.pricing?.data?.pricingCategories?.data || []
  const adultCategory = categories.find(
    (cat) => cat.ticket_category === 'ADULT'
  )
  const firstCategory = categories[0]
  const scales =
    adultCategory?.pricingScales?.data || firstCategory?.pricingScales?.data
  const lowestRetailPrice =
    scales?.[scales.length - 1]?.price?.data?.retail_price

  if (!lowestRetailPrice) return undefined

  const promotion = kftEvent?.activePromotion?.data
  const originalPriceAmount = Number(lowestRetailPrice)
  const discountedAmount = calculatePromotionDiscount(
    originalPriceAmount,
    promotion
  )
  const finalPriceAmount =
    discountedAmount !== undefined ? discountedAmount : originalPriceAmount

  const formatted = formatMoney(finalPriceAmount, localeBCP47, 'EUR', 2)
  return t(PRICE_FROM_KEY) + ' ' + formatted
}

export const getTieredSubtitleProps = (
  fromPricePerPerson: string | undefined
): TieredSubtitleProps | null =>
  fromPricePerPerson ? { variant: 'tiered', fromPricePerPerson } : null
